<template>
  <v-container fluid pa-3 v-scroll="onScrollFunction" class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
    <filter-component :json_data="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px;"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12>
        <v-tooltip top>
          <v-btn
            slot="activator"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top:5rem;margin-bottom:15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer">
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top:40px;padding-bottom:40px;"
              >
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{$t('AddCheckInOut')}}</h3>
              </div>
            </template>
            <span>{{$t('ClickFor')}} {{$t('AddCheckInOut')}}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      
          
      <v-layout pa-1 style="margin-left:30px;">
        <v-flex xs4 sm4 >
           <v-select
              :items="type_Time"
              :item-text="$t('txt')"
              item-value="val"
              :label="$t('type')"
              v-model="number_tab"
              @change="checktab()"
            >
              <template slot="item" slot-scope="{item}">
                <div>{{ $t(''+item.txt) }}</div>
              </template>
            </v-select>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex md12 sm12 xs12 v-for="(item, index) in table_data" :key="index" @click="''">
            <v-card class="coco-box-shadow coco-list-hover">
              <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                <v-flex lg1 md1 sm2 xs3 text-xs-center>
                  <v-avatar :size="64">
                    <v-avatar
                      v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                      :size="64"
                      color="teal"
                    >
                      <span class="white--text headline">{{item.nick_name}}</span>
                    </v-avatar>

                    <Empimage
                      v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                      :json_data="item.emp_images"
                    />
                  </v-avatar>
                </v-flex>
                <v-flex lg9 md9 sm8 xs9>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <span
                        class="coco-list-label-text"
                      >{{isEmpty(item.usercode)? item.usercode : 'emp_code'}}:</span>
                      <span>{{item.firstName}} {{item.lastName}}</span>
                      <span
                        v-html="' (<span style=color:#166BFF;>'+(isEmpty(item.nick_name) ? item.nick_name : 'nick_name')+'</span>)'"
                      />
                    </v-flex>
                    <v-flex xs12 class="hidden-xs-only">
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('branch')}}:
                        <span>
                          {{isEmpty(item.branch)? item.branch
                          : 'branch'}}
                        </span>
                      </span>
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Department')}}:
                        <span>
                          {{isEmpty(item.department_name) ?
                          item.department_name : 'department_name'}}
                        </span>
                      </span>
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Position')}}:
                        <span>
                          {{isEmpty(item.position) ?
                          item.position : 'position'}}
                        </span>
                      </span>
                      <span class="coco-list-label-icon">
                        <v-icon>assignment</v-icon>
                        <span>{{isEmpty(item.doc_no) ? item.doc_no : "doc_no"}}</span>
                      </span>
                      <span class="coco-list-label-icon">
                        <v-icon>access_time</v-icon>
                        <span>{{formatDate(item.check_in_time, formatDates)}}</span>
                      </span>
                      <span
                        class="coco-list-label-icon"
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">assignment</v-icon>
                        <span>{{item.doc_no}}</span>
                      </span>
                      <span
                        class="coco-list-label-icon"
                        v-show="(item.remark != '' && item.remark != undefined && item.remark != null)"
                      >
                        <v-icon>info</v-icon>
                        <span>{{item.remark}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">access_time</v-icon>
                        <span>{{formatDate(item.check_in_time, formatDates)}}</span>
                      </span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg2 md2 sm2 xs2>
                  <v-layout row wrap class="hidden-xs-only">
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 lgุ12 md12>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="hidden-sm-and-up">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                  <v-divider />
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <v-dialog v-model="delDialogStatus" persistent max-width="300">
          <v-card>
            <v-toolbar dark color="blue d-1">
              <v-toolbar-title>
                <v-icon :size="20" class="px-2">fa-question-circle</v-icon>
                <span>{{$t('info.confirm_delete')}}</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              ต้องการลบข้อมูลเวลาของ
              <br />
              รหัส:{{delDialog.name}}
              <br />
              เวลา:{{delDialog.time}} ใช่หรือไม่?
            </v-card-text>
            <v-card-actions>
              <v-layout row wrap>
                <v-flex xs6 pa-1>
                  <v-btn
                    color="error"
                    outline
                    block
                    @click="delDialogStatus = false"
                  >{{$t('cancel')}}</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="success" outline block @click="onDelete()">{{$t('submit')}}</v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <!-- FrmDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="dialog_data" v-on:close-dialog="onCloseDialog" />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import FrmDialog from "./FormDialog";
import Empimage from "../../components/getempimage.vue";
import Utils from "@/utils/";
import $ from "jquery";
import FilterComponent from "./Filter";

export default {
  data: () => ({
    type_Time: [
      { txt: "Absence", val: 0 },
      { txt: "TakeLeave", val: 1 },
      { txt: "Late", val: 2 },
      { txt: "DepartBeforeTime", val: 3 },
      { txt: "Specialholiday", val: 4 }
    ],
    number_tab:0,
    Search_data: "",
    show_search: false,
    dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    table_data: [],
    pageActive: 1,
    processing: false,
    canLoadMore: true,
    delDialogStatus: false,
    delDialog: {
      roworder: "",
      name: "",
      time: ""
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    form_dialog_data: {
      status: false
    }
  }),
  created: function() {
    // this.setShowFilter({
    //   status: 0
    // });
    this.commitSetToolbar({
      patternTool: "0"
    });
    this.getCheckinoutList();
    this.getEmployee("newData");

    // this.$store.watch(
    //   state => {
    //     state.filter.SelectBranch;
    //     state.filter.SelectDepartment;
    //     state.filter.SelectPosition;
    //     state.filter.SearchData;
    //     state.filter.FromDate;
    //     state.filter.ToDate;
    //   },
    //   () => {
    //     this.pageActive = 1;
    //     this.table_data = [];
    //     this.canLoadMore = true;
    //     this.getCheckinoutList();
    //   },
    //   {
    //     deep: true
    //   }
    // );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    Empimage,
    FrmDialog,
    FilterComponent
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", ["showLoading", "formatDates"]),
    ...mapState("filter", ["Employee_List"])
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    onCloseDialog() {
      this.getCheckinoutList();
      this.pageActive = 1;
      this.table_data = [];
      this.dialog_data.status = false;
    },
    checktab(){
      this.number_tab ;
      console.log(this.number_tab);
    },

    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      this.getCheckinoutList();
    },
    onHandleDialog(status, save_type, data) {
      this.dialog_data = {
        status: status,
        save_type: save_type,
        data: this.number_tab
      };
    },
    onHandleAlert(status, message) {
      this.alert_data = {
        status: true,
        message: err
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          this.getCheckinoutList();
        }
      }
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    getCheckinoutList() {
      this.commitSetShowLoading(true);
      DocumentService.getCheckinoutList(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.SearchData,
        this.pageActive,
        this.FromDate,
        this.ToDate
      )
        .then(res => {
          if (this.table_data.length > 0) {
            if (res.data.content.length > 0) {
              this.table_data = [];
              res.data.content.forEach(data => {
                this.table_data.push(data);
              });
            } else {
              this.canLoadMore = false;
            }
          } else {
            this.table_data = res.data.content;
            console.log(this.table_data);
          }
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    deleteItem(data) {
      this.delDialog.roworder = data.roworder;
      this.delDialog.name = data.firstName + data.lastName;
      this.delDialog.time = data.check_in_time;
      this.delDialogStatus = true;
    },
    onDelete() {
      DocumentService.deleteCheckinTime(this.delDialog.roworder)
        .then(res => {
          this.showSnackBar("delete success", "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getCheckinoutList();
          this.delDialogStatus = false;
        })
        .catch(err => {
          console.log(err);

          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    showFilter(status) {
      this.form_dialog_data = {
        status: status,
        data: 1
      };
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    }
  }
};
</script>
